export const useMailConfirm = el => {
  const { $gsap: gsap, $SplitText, $mq, $Lenis } = useNuxtApp();

  const isModalVisible = useMailConfirmModal();
  const isAboutVisible = useAboutModal();
  const isAnimating = ref(false);
  const countdown = ref(5);
  const global = useGlobal();
  const email = global?.value?.email;

  let ctx;
  let countdownInterval;
  let splitText;

  const startCountdown = () => {
    let mailEl = qs('.mail__timer', el.value);
    countdown.value = countdown.value;
    countdownInterval = setInterval(() => {
      countdown.value -= 1;

      // Add animated class
      if (mailEl) {
        mailEl.classList.add('is-animated');
        setTimeout(() => {
          mailEl.classList.remove('is-animated');
        }, 250);
      }

      if (countdown.value <= 0) {
        clearInterval(countdownInterval);
        animateOut();
      }
    }, 1000);
  };

  const stopCountdown = () => {
    if (countdownInterval) {
      clearInterval(countdownInterval);
      countdownInterval = null;
    }
  };

  const animateIn = () => {
    if (isAnimating.value) return;
    isAnimating.value = true;

    // Stop global Lenis to prevent conflicts
    // $Lenis?.stop();

    gsap.delayedCall(0.5, () => {
      el.value.classList.add('is-animated');
    });
    gsap.timeline().to(
      el.value,
      {
        y: 0,
        duration: 1.25,
        force3D: true,
        ease: 'smooth',
        onComplete: () => {
          isAnimating.value = false;
          startCountdown();
        },
      },
      '<'
    );
  };

  const animateOut = () => {
    if (isAnimating.value) return;
    isAnimating.value = true;

    stopCountdown();

    gsap
      .timeline({
        onComplete: () => {
          isModalVisible.value = false;
          isAnimating.value = false;
          // Restart global Lenis
          $Lenis?.start();
        },
      })

      .to(
        el.value,
        {
          y:
            gsap.getProperty(el.value, 'bottom') +
            gsap.getProperty(el.value, 'height'),
          force3D: true,
          duration: isAboutVisible ? 0.5 : 1.25,
          ease: 'expo.out',
        },
        '<'
      );
  };

  const initSplitText = () => {
    ctx = gsap.context(() => {
      animateIn();
      $SplitText.create(qsa('[data-split]', el.value), {
        type: 'lines',
        mask: 'lines',
        autoSplit: true,
        linesClass: 'line',
        wordsClass: 'word',
        smartWrap: true,
        onSplit: self => {
          self?.lines?.forEach((myLine, i) => {
            gsap.set(myLine, { '--index': i });
          });
        },
      });
    }, el.value);

    // Copy email to clipboard
    if (email && navigator.clipboard) {
      navigator.clipboard.writeText(email).catch(err => {
        console.error('Failed to copy email to clipboard:', err);
      });
    }
  };

  const cleanup = () => {
    stopCountdown();
    ctx?.revert();

    // Ensure global Lenis is restarted
    $Lenis?.start();
  };

  return {
    animateOut,
    initSplitText,
    cleanup,
    countdown,
  };
};
